import { ReactElement } from "react"
import { Navbar } from "../Navbar";
import { Footer } from "../Footer";
import Head from "next/head";

type Props = {
    children: ReactElement;
    background?: string
}


export const Layout = ({ children, background }: Props) => {
    return (
        <>
            <Head>
                <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
                <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
                <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
                <link rel="manifest" href="/site.webmanifest" />
                <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
                <meta name="msapplication-TileColor" content="#da532c" />
                <meta name="theme-color" content="#ffffff" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <title>Crie sua campanha de forma fácil e rápida</title>
                {/* <!-- Primary Meta Tags --> */}
                <meta name="description" content="Crie sua campanha de forma fácil e rápida!" />

                {/* <!-- Open Graph / Facebook --> */}
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://rifaweb.digital/" />
                <meta property="og:title" content="Rifaweb" />
                <meta property="og:description" content="Crie sua campanha de forma fácil e rápida!" />
                <meta property="og:image" content="logo-rifaweb.jpg" />

                {/* <!-- Twitter --> */}
                <meta property="twitter:card" content="summary_large_image" />
                <meta property="twitter:url" content="https://rifaweb.digital/" />
                <meta property="twitter:title" content="Rifaweb" />
                <meta property="twitter:description" content="Crie sua campanha de forma fácil e rápida!" />
                <meta property="twitter:image" content="logo-rifaweb.jpg" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://www.youtube.com" />
            </Head>
            <div className={`flex flex-col justify-between ${background ? background : 'bg-white'}`}>
                <Navbar />
                <div className="block relative w-full h-[80px]"></div>
                <main className="w-full h-full relative pb-16">
                    {children}
                </main>
                <Footer />
            </div>
        </>

    );

}